/* eslint-disable @next/next/no-html-link-for-pages */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-empty-interface */
// import PayMessagePolicy from '@/components/PayMessagePolicy';
import PriceDetails from '@/components/PriceDetails';
import { style } from '@/styles/globals';
import { useAppSelector } from '@/utils/hook';
import { pr } from '@/utils/pxToRem';
import { getTotalDiscountAmount } from '@/utils/tripMapping';
import { LoadingButton } from '@mui/lab';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import {
  Box, Stack, Typography,
} from '@mui/material';
import { get, isEmpty } from 'lodash';
import { useRouter } from 'next/router';
import qs from 'qs';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setOrderId } from '@/slices/global/globalSlice';
import PriceDetailsApi from '@/components/PriceDetailsApi';
import WrapperContainer from '@/components/WrapperContainer';

interface TripDetailPriceProps {
  onBtnClick?: () => void;
  isPayment?: boolean;
  isDisabled?: boolean;
  isLoadDataFromApi?: boolean;
  isLoadingProps?: boolean;
}

export const TripDetailPriceFixedComponent = ({
  isPayment, priceDetailsObj, handleNextPage, isLoading, isLoadDataFromApi, orderData,
}: any) => {
  const PriceDetailsComponent = isLoadDataFromApi ? PriceDetailsApi : PriceDetails;
  const { query } = useRouter();

  return (
    <Stack spacing={isPayment ? pr`16px` : pr`24px`}>
      <Box
        sx={{
          background: 'white',
          borderRadius: '3px',
        }}
      >
        <PriceDetailsComponent
          orderData={orderData}
          isDesktop
          isPayment={isPayment}
          flightPriceDiff={priceDetailsObj.flightPriceDiff}
          priceDetailsObj={priceDetailsObj}
          flightArr={priceDetailsObj.flightArr}
          passenger={priceDetailsObj.passenger}
          baggagePriceDepart={priceDetailsObj.departBaggagePrice}
          baggagePriceReturn={priceDetailsObj.returnBaggagePrice}
          discountAmount={priceDetailsObj.totalDiscountAmount}
          onCloseButton={() => {}}
          onNextButton={handleNextPage}
        />
      </Box>
      {/* {isPayment && (
      <PayMessagePolicy
        sx={{ p: 0 }}
        onToPolicyPage={() => router.push('/pay/privacy-policy')}
      />

    )} */}
      <Box sx={{
        position: 'fixed',
        width: '100vw',
        background: 'white',
        left: 0,
        bottom: 0,
        zIndex: 9,
      }}
      >
        <WrapperContainer>
          <Stack
            width="100%"
            direction="row"
            justifyContent="flex-end"
            boxSizing="border-box"
            alignItems="center"
            sx={{
              padding: '26px 0',
              justifyContent: 'space-between',
            }}
          >
            <Stack>
              <Typography variant="contentRegular">
                <FiberManualRecordIcon sx={{ fontSize: '10px' }} />
                {' '}
                Bạn sẽ thanh toán trực tiếp vào tài khoản
                {' '}
                <strong>VeXeRe - Công ty chủ quản của Goyolo</strong>
              </Typography>
              <Typography variant="contentRegular">
                <FiberManualRecordIcon sx={{ fontSize: '10px' }} />
                {' '}
                Bằng việc bấm nút thanh toán, bạn đã đồng ý với
                {' '}
                <a
                  style={{ textDecorationColor: '#12A8A6' }}
                  href="pay/privacy-policy"
                >
                  <strong style={{
                    color: '#12A8A6',
                  }}
                  >
                    Chính sách bảo mật của Goyolo
                  </strong>
                </a>
                {' '}
              </Typography>
            </Stack>
            <LoadingButton
              color="primary"
              loading={isLoading}
              disabled={isLoading}
              onClick={handleNextPage}
              variant="contained"
              sx={{
                p: ` ${pr`12px`} 0`,
                width: '370px',
              }}
            >
              <Typography
                color={style.color.white4}
                variant="contentBold"
              >
                {query?.type === 'depart' ? 'Chọn vé chiều về' : isPayment ? 'Thanh toán' : 'Tiếp tục'}
              </Typography>
            </LoadingButton>
          </Stack>
        </WrapperContainer>

      </Box>
    </Stack>
  );
};

const TripDetailPrice: React.FC<TripDetailPriceProps> = ({
  onBtnClick,
  isPayment,
  isLoadDataFromApi,
  isLoadingProps,
}) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const query = isEmpty(router.query)
    ? qs.parse(router.asPath.split('?')[1]) || {}
    : router.query;
  const [isLoadingPayment, setLoading] = useState(!!isPayment);
  const isLoading = isLoadingProps || isLoadingPayment;

  const passenger = useAppSelector((state) => state.searchFlightForm.passenger);

  const myBookingFlight = useAppSelector((state) => state.myBooking.flights);

  const selectedFlightCache = useMemo(
    () => myBookingFlight.find(
      (flight) => (flight.bookingCode === query?.code) || (flight.id === Number(query?.id || 0)),
    ),
    [myBookingFlight],
  );

  const reserveResponse = useAppSelector(
    (state) => state.global.reserveResponse,
  );
  let orderId = useAppSelector((state) => state.global.orderId);
  if (reserveResponse && isLoadingPayment) {
    const order = get(reserveResponse, 'orders[0]');
    if (order && order.id) {
      orderId = order.id;
      dispatch(setOrderId({ orderId }));
    }
    setLoading(false);
  }

  if (isPayment && !isPayment) {
    setTimeout(
      () => router.push('/route-flight', {}, { shallow: true }),
      60 * 1000,
    );
  }

  useEffect(() => {
    if (selectedFlightCache) {
      setLoading(false);
    }
  }, []);

  const selectedFlight = useAppSelector((state) => state.selectedFlight.flight);
  const selectedReturnFlight = useAppSelector(
    (state) => state.selectedFlight.returnFlight,
  );
  const {
    flightPriceDiff,
    returnFlightPriceDiff,
    discountAmount,
    returnDiscountAmount,
  } = useAppSelector((state) => state.selectedFlight);
  const selectedBaggages = useAppSelector(
    (state) => state.baggage.selectedBaggages,
  );

  if (!selectedFlight) {
    return <></>;
  }

  let departBaggagePrice = 0;
  let returnBaggagePrice = 0;
  departBaggagePrice = (selectedBaggages.depart || []).reduce(
    (total, baggageData) => total + baggageData.baggage.price,
    0,
  );
  returnBaggagePrice = (selectedBaggages.return || []).reduce(
    (total, baggageData) => total + baggageData.baggage.price,
    0,
  );

  const totalBaggagePrice = departBaggagePrice + returnBaggagePrice;

  const totalDiscountAmount = getTotalDiscountAmount(
    discountAmount + returnDiscountAmount,
    passenger,
  );
  const handleNextPage = () => {
    dispatch(setOrderId({ orderId: '' }));
    onBtnClick?.();
  };
  const priceDetailsObj = {
    flightPriceDiff: flightPriceDiff + returnFlightPriceDiff,
    flightArr: [selectedFlight].concat(
      selectedReturnFlight ? [selectedReturnFlight] : [],
    ),
    passenger,
    totalBaggagePrice,
    departBaggagePrice,
    returnBaggagePrice,
    totalDiscountAmount,
  };
  return (
    <TripDetailPriceFixedComponent
      isLoadDataFromApi={isLoadDataFromApi}
      isPayment
      priceDetailsObj={priceDetailsObj}
      handleNextPage={handleNextPage}
      isLoading={isLoading}
    />
  );
};

export default TripDetailPrice;
